import api from '@/utils/api';
import axios from 'axios';



 export const localRouter_meun_hunan = [ //产业招商大脑导航栏顺序
    //工作台
{
    code: "E",
    switch: true,
    name: "",
    oldtext: "找项目",
    type: "zxm",
    url: "/findProjects",
    open: false,
    openicon: false,
    morebtn: false,
    icontype: "el-icon-s-order",
    children: [
           {
                code: "E-xlrxm",
                switch: true,
                name: "",
                oldtext: "新录入项目",
                url: "/findProjects",
                value: 100,
                num: 0
                
            }, 
            {
                code: "E-ylrxm",
                switch: true,
                name: "",
                oldtext: "已录入项目",
                url: "/projectList",
                value: 0,
                num: 0
                
            }, 
    ]
},
{
    code: "A",
    switch: true,
    name: "",
    oldtext: "评项目",
    type: "pxm",
    url: "/evaluationProject?type=1",
    open: false,
    morebtn: false,
    icontype: "el-icon-s-order",
    children: [
        {
            code: "A-dpxm",
            switch: true,
            name: "",
            oldtext: "待评项目",
            url: "/evaluationProject?type=1",
            value: 1,
            num: 0
            }, 
         {
            code: "A-pgzxm",
            switch: true,
            name: "",
            oldtext: "评估中项目",
            url: "/evaluationProject?type=17",
            value: 17,
            num: 0
        }, 
        {
            code: "A-ypxm",
            switch: true,
            name: "",
            oldtext: "已评项目",
            url: "/evaluationProject?type=2",
            value: 2,
                num: 0
        }
    ]
},
{
    code: "F",
    switch: true,
    name: "",
    oldtext: "推项目",
    type: "txm",
    url: "/pushProject?type=3",
    open: false,
    morebtn: false,
    icontype: "el-icon-s-order",
    children: [
        {
            code: "F-wtsxm",
            switch: true,
            name: "",
            oldtext: "未推送项目",
            url: "/pushProject?type=3",
            value: 3,
                num: 0
        },
        {
            code: "F-ytsxm",
            switch: true,
            name: "",
            oldtext: "已推送项目",
            url: "/pushProject?type=4",
            value: 4,
                num: 0
        },
        {
            code: "F-yjsxm",
            switch: true,
            name: "",
            oldtext: "已接收项目",
            url: "/pushProject?type=5",
            value: 5,
                num: 0
        },
        {
            code: "F-tschxm",
            switch: true,
            name: "",
            oldtext: "推送撤回记录",
            url: "/recallRecord",
            value: 99,
            num: 0
        },
        {
            code: "G-xmdjz",
            switch: true,
            name: "",
            oldtext: "项目对接中",
            url: "/implementProject?type=7",
            value: 7,
            num: 0
        },
        {
            code: "G-yzhxz",
            switch: true,
            name: "",
            oldtext: "已智慧选址",
            url: "/implementProject?type=8",
            value: 8,
                num: 0
        },
        {
            code: "G-ysdkc",
            switch: true,
            name: "",
            oldtext: "已实地考察",
            url: "/implementProject?type=9",
            value: 9,
                num: 0
        },
        {
            code: "G-xmtpz",
            switch: true,
            name: "",
            oldtext: "项目谈判中",
            url: "/implementProject?type=10",
            value: 10,
                num: 0
        },
        {
        code: "G-gxxm",
        switch: true,
        name: "",
        oldtext: "共享项目",
        url: "/publicProject?type=16",
        value: 16,
        num: 0
    },
    ]
},
{
    code: "G",
    switch: true,
    name: "",
    oldtext: "落项目",
    type: "lxm",
    url: "/implementProject?type=6",
    open: false,
    morebtn: false,
    icontype: "el-icon-s-order",
    children: [
        // {
        //     code: "G-xmxz",
        //     switch: true,
        //     name: "",
        //     oldtext: "项目协作",
        //     url: "/implementProject?type=99"
        // },
        {
            code: "G-qbxm",
            switch: true,
            name: "",
            oldtext: "全部项目",
            url: "/implementProject?type=6",
            value: 6,
                num: 0
        },
        
        {
            code: "G-yldqy",
            switch: true,
            name: "",
            oldtext: "已落地签约",
            url: "/implementProject?type=11",
            value: 11,
                num: 0
        },
        {
            code: "G-ygdzc",
            switch: true,
            name: "",
            oldtext: "已购地租厂",
            url: "/implementProject?type=12",
            value: 12,
                num: 0
        },
        {
            code: "G-ykgjs",
            switch: true,
            name: "",
            oldtext: "已开工建设",
            url: "/implementProject?type=13",
            value: 13,
                num: 0
        },
        {
            code: "G-yscyy",
            switch: true,
            name: "",
            oldtext: "已生产运营",
            url: "/implementProject?type=14",
            value: 14,
            num: 0
        },
        
        {
            code: "G-ztxm",
            switch: true,
            name: "",
            oldtext: "暂停项目",
            url: "/implementProject?type=20",
            value: 20,
                num: 0
        },
    ]
},
//产业招商
{
    code: "J",
    switch: true,
    name: "",
    oldtext: "广东企业库",
    url: "GD-enterprise",
    open: false,
    morebtn: false,
    icontype: "el-icon-s-management",
    children: []
},
{
    code: "I",
    switch: true,
    name: "",
    oldtext: "商学政工库",
    url: "/hometownInvestment",
    open: false,
    morebtn: false,
    icontype: "el-icon-s-management",
    children: []
},
{
    code: "C",
    switch: true,
    name: "",
    oldtext: "投资机构库",
    url: "/investment-institutions",
    open: false,
    morebtn: false,
    icontype: "el-icon-menu",
    children: []
},
//产业研究
{
    code: "B",
    switch: true,
    name: "",
    oldtext: "招商图谱库",
    url: "/allchain",
    open: false,
    morebtn: false,
    icontype: "el-icon-s-management",
    children: []
},
//智能推荐
{
    code: "R",
    switch: true,
    name: "",
    oldtext: "研究报告库",
    url: "/report?type=w0",
    open: false,
    morebtn: false,
    icontype: "el-icon-s-opportunity",
    children: []
},
//关系计算器
{
    code: "D",
    switch: true,
    name: "",
    oldtext: "行研智能体",
    url: "/trade",
    open: false,
    morebtn: false,
    icontype: "el-icon-s-platform",
    children: []
},
//个人中心
{
    code: "H",
    switch: true,
    name: "",
    oldtext: "个人中心",
    url: "/baseInformation",
    open: false,
    openicon: false,
    morebtn: false,
    icontype: "el-icon-s-custom",
    children: []
},
]

// let userdata = JSON.parse(sessionStorage.getItem('userData')||localStorage.getItem('userData'));
// let menuList =[];
// let url = api.crm.parameter.menuList();
// axios.get(url, {
//     headers: {
//         AuthToken:userdata.token,
//     }
// }).then((res) => {
//     console.log('menuList',res);
//     if (res.data.success) {
//         let resdata = res.data.list;
//         menuList = resdata;
//         //用menuList去匹配localRouter_meun_hunan中的chrildren,然后把menuList中的num添加到localRouter_meun_hunan中
 
//             localRouter_meun_hunan.forEach(item => {
//             item.children.forEach(childItem => {
//                 let matchItem = menuList.find(dataItem => dataItem.value == childItem.value);
//                 // console.log('matchItem',matchItem,childItem.value);
//                 if (matchItem) {
//                     childItem.num = matchItem.num;
//                 }
//             });
//         }); 
//         console.log('localRouter_meun_hunan',localRouter_meun_hunan);   
//     }
// });

// export default localRouter_meun_hunan;